import DeviceDetectionMixin from "../mobile_detection/DeviceDetectionMixin";

export default {
  mixins: [DeviceDetectionMixin],
  computed: {
    user() {
      return this.$store.state.global && this.$store.state.global.user;
    },
    isUserNotAuthed() {
      return this.$store.getters["global/isUserNotAuthed"];
    },
    isUserAuthedNotRegistered() {
      return this.$store.getters["global/isUserAuthedNotRegistered"];
    },
    isUserInProject() {
      return this.$store.getters["global/isUserInProject"];
    },
    /**
     * @returns boolean
     */
    isSteamUser() {
      return this.$store.getters["global/isSteamUser"];
    },
    /**
     * @returns boolean
     */
    isPSUser() {
      return this.$store.getters["global/isPSUser"];
    },
    /**
     * @returns boolean
     */
    isXboxUser() {
      return this.$store.getters["global/isXboxUser"];
    },
    /**
     * @returns boolean
     */
    isSteamPsXboxUser() {
      return this.isSteamUser || this.isPSUser || this.isXboxUser;
    },
    getUserPlatform() {
      return this.$store.getters["global/getUserPlatform"];
    },
    isUserProcessed() {
      return this.$store.getters["global/isUserProcessed"];
    },
    userFields() {
      if (!this.user) return [];

      return Object.keys(this.user.fields);
    },
    isPreorderBought() {
      if (!this.user) return false;

      return this.userFields.some(field => field.includes("preorder"));
    },
    userTechnicalNickname() {
      return this.$store.getters["global/getUserTechnicalNickname"];
    },
  },

  methods: {
    login() {
      if (this.isUserNotAuthed) {
        this.$authService.showSignin();
      }
      if (this.isUserAuthedNotRegistered) {
        this.$authService.showProjectReg();
      }
    },
    register() {
      if (this.isUserNotAuthed) {
        this.$authService.showSignup();
      }
      if (this.isUserAuthedNotRegistered) {
        this.$authService.showProjectReg();
      }
    },
    logout() {
      if (this.$authService) {
        this.$authService.logout();
      }
    },
    gameDownload(game_link = "", need_auth = true, device_check = false) {
      if (need_auth && !this.isUserInProject) {
        this.login();
      } else {
        this.m_checkDeviceAndDownload(device_check, game_link);
      }
    },
    m_checkDeviceAndDownload(device_check = false, game_link = "") {
      if (!device_check || this.isWindowsOs) {
        this.$authService.downloadGameCenter(game_link);
      } else {
        this.$store.commit("global/setWrongDevice", true);
      }
    },
  },
};
